export default "https://cdn-static.gokick.com/assets/d6a1d1f7abc93216fd07fb40adb7adf28904b072/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";